// Utilidades de texto compartidas por las vistas que muestran extractos.
//
// Motivo: el editor guarda los cuerpos sembrados de &nbsp;. Un espacio duro no
// permite cortar la línea, así que un párrafo lleno de ellos se convierte en una
// sola línea indivisible que se sale de su contenedor y pisa lo que tenga al
// lado. Cada vista tenía su propia copia de esta lógica y solo algunas lo
// contemplaban; ahora hay una única implementación.

const ESPACIO_DURO = /\u00a0/g;
const ENTIDAD_ESPACIO_DURO = /&nbsp;/gi;

/** Sustituye los espacios duros por espacios normales conservando el marcado. */
export const limpiarEspaciosDuros = (html) =>
  (html || '').replace(ENTIDAD_ESPACIO_DURO, ' ').replace(ESPACIO_DURO, ' ');

/** Texto plano, sin marcado, con los espacios normalizados y recortado. */
export const resumenPlano = (html, maxCaracteres = 100) => {
  const contenedor = document.createElement('div');
  contenedor.innerHTML = html || '';
  const parrafo = contenedor.querySelector('p');
  let texto = (parrafo ? parrafo.textContent : contenedor.textContent) || '';
  texto = texto.replace(ESPACIO_DURO, ' ').replace(/\s+/g, ' ').trim();
  if (maxCaracteres && texto.length > maxCaracteres) {
    texto = texto.substring(0, maxCaracteres) + '...';
  }
  return texto;
};

/**
 * Primer párrafo como HTML, conservando el marcado en línea (negritas,
 * enlaces) pero con los espacios duros ya neutralizados.
 */
export const primerParrafoHtml = (html) => {
  const contenedor = document.createElement('div');
  contenedor.innerHTML = html || '';
  const parrafo = contenedor.querySelector('p');
  const contenido = parrafo ? parrafo.innerHTML : contenedor.innerHTML;
  return limpiarEspaciosDuros(contenido);
};

/**
 * Prepara el cuerpo de un artículo para pintarlo: neutraliza los espacios duros
 * y da un alt vacío a las imágenes que no lo traen.
 *
 * Un alt ausente hace que el lector de pantalla lea la URL del archivo, que no
 * dice nada. Un alt vacío indica "imagen sin información añadida" y se omite.
 * Lo correcto sería que el panel permitiera escribir la descripción al subir
 * la imagen; esto es la red mientras tanto.
 */
export const prepararCuerpo = (html) =>
  limpiarEspaciosDuros(html).replace(
    /<img(?![^>]*alt=)([^>]*)>/gi,
    '<img alt=""$1>'
  );
